/**
 * Created by cavin on 2020/7/15.
 */
require("../lib-sass/health.scss");
require("../sass/client.scss");

var $ = require("jquery");
var base = require("../lib-js/base");
var lib = require("../lib-js/mtop.min.js");

$(function () {

  function boot(callback) {
    base.sendRequest([{
      postData: {},
      config: {
        api: 'mtop.alihealth.drug.d2d.tool.clientinstall'
      }
    }], function (res) {
      if (res && res[0]) {
        var model = res[0].data.model || {};
        base.render("#main-tmpl", "#container1", { data: {
            crtDate: model.crtDate || '',
            size: model.size || '',
            versionNum: model.versionNum || ''
          } });
        $("#downloadClient").on('click', function () {
          window.location.href = model.resourceUrl || '';
        });
      }
    }, function (data) {});
  }
  boot();
});


/*****************
 ** WEBPACK FOOTER
 ** ./pages/home/js/client.js
 ** module id = 0
 ** module chunks = 2
 **/